import { z } from 'zod';
import { validatedGet, validatedPost, validatedDelete, validatedPatch } from '../api-client.ts';
import { DisdettaSchema } from '@/types/entities/index.ts';
import { DisdettaArricchitaSchema } from '@/types/api-responses.ts';
import type { CassaCode, TipoDisdetta } from '@/types/entities/index.ts';
import { OkResult } from './shared.ts';

const DisdetteListResult = z.object({
  disdette: z.array(DisdettaArricchitaSchema),
  count: z.number(),
});

const ListaPaginataResult = z.object({
  disdette: z.array(DisdettaArricchitaSchema),
  count: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
});

const VerificaResult = z.object({
  warnings: z.array(z.string()),
  ok: z.boolean(),
});

type FiltriDisdette = {
  tipo?: TipoDisdetta;
  sigla?: string;
  cassa?: CassaCode;
  da?: string;
  a?: string;
  lavoratoreId?: number;
};

interface ListaDisdetteParams {
  [key: string]: string | number | undefined;
  page?: number;
  limit?: number;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  q?: string;
  tipo?: string;
  sigla?: string;
  cassa?: string;
  da?: string;
  a?: string;
  nascosta?: string;
  origine?: string;
}

export const disdetteApi = {
  listaPaginata: (params: ListaDisdetteParams = {}) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== '') qs.set(k, String(v));
    }
    const url = `disdette/lista${qs.toString() ? '?' + qs.toString() : ''}`;
    return validatedGet(url, ListaPaginataResult);
  },

  lista: (filtri?: FiltriDisdette) => {
    const params = new URLSearchParams();
    if (filtri) {
      if (filtri.tipo) params.set('tipo', filtri.tipo);
      if (filtri.sigla) params.set('sigla', filtri.sigla);
      if (filtri.cassa) params.set('cassa', filtri.cassa);
      if (filtri.da) params.set('da', filtri.da);
      if (filtri.a) params.set('a', filtri.a);
      if (filtri.lavoratoreId) params.set('lavoratoreId', String(filtri.lavoratoreId));
    }
    const qs = params.toString();
    return validatedGet(`disdette${qs ? `?${qs}` : ''}`, DisdetteListResult);
  },

  dettaglio: (id: number) =>
    validatedGet(`disdette/${id}`, DisdettaSchema),

  crea: (dati: {
    lavoratoreId: number;
    cassa: CassaCode;
    tipo: TipoDisdetta;
    sigla?: string | null;
    dataDisdetta: string;
    note?: string;
  }) =>
    validatedPost('disdette', dati, DisdettaSchema),

  verifica: (dati: { lavoratoreId: number; cassa: CassaCode; tipo: TipoDisdetta; sigla: string }) =>
    validatedPost('disdette/verifica', dati, VerificaResult),

  elimina: (id: number) =>
    validatedDelete(`disdette/${id}`, OkResult),

  collegaDelega: (id: number, delegaId: number) =>
    validatedPatch(`disdette/${id}/collega-delega`, { delegaId }, OkResult),
};
